// extracted by mini-css-extract-plugin
export var card = "card-module--card--9d772";
export var cardButtons = "card-module--cardButtons--fa49d";
export var cardCopy = "card-module--cardCopy--43c21";
export var cardHeadline = "card-module--cardHeadline--3ece7";
export var cardIcon = "card-module--cardIcon--3f5d1";